// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3RYMG","subheader":"ReorderModal_subheader__2tRBV","listWrap":"ReorderModal_listWrap__2o8yt"};